import $ from 'jquery';

(() => {


  let _baseWhidth = 375;

  if($(window).width() < 768){

    let zoom = $(window).width() / _baseWhidth;

    let _mainCopyHeight = 600;
    let _profileHeight = 478;
    let _interview1Height = 1662 + 65;
    let _interview2Height = 1013 + 20;
    let _interview3Height = 975;
    let _interview4Height = 1052;
    let _interview5Height = 1206;
    let _fittingHeight = 667;
    let _shindanHeight = 327;
    let _erabikataHeight = 2965;


    $(".mainCopy").height(_mainCopyHeight * zoom);
    $(".profile").height(_profileHeight * zoom);
    $(".interview1").height(_interview1Height * zoom);
    $(".interview2").height(_interview2Height * zoom);
    $(".interview3").height(_interview3Height * zoom);
    $(".interview4").height(_interview4Height * zoom);
    $(".interview5").height(_interview5Height * zoom);
    $(".fitting").height(_fittingHeight * zoom);
    $(".shindan").height(_shindanHeight * zoom);
    // $(".erabikata").height(_erabikataHeight * zoom);
    $(".erabikata").css({'min-height':_erabikataHeight * zoom});

  }


  $('a.anc').click(function () {
    var speed = 1000;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;
    console.log(href,position);

    //スクロール位置補完
    switch(href){
      case "#anc-interview05":
        if($(window).width() < 768){
          position = position - 100;
        } else {
          position = position - 92;
        }
        break;
      case "#anc-fitting":
        if($(window).width() < 768){
          position = position + 100;
        } else {
          position = position + 380;
        }
        break;
      case "#anc-lineup":
        position = position + 20;
        break;
    }


    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });
})();
